import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/filter/car.svg'
import _imports_1 from '../../../assets/filter/box.svg'


const _withScopeId = n => (_pushScopeId("data-v-d0cefeac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "excluirSelecionadoUnico",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "exampleModalLongTitle"
  }, "Excluir produto do veiculo"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_6 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_7 = { class: "card d-flex flex-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = {
  class: "w-100",
  id: "ulPaiListaCard"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "titulosDoModal" }, "Veiculo selecionado", -1))
const _hoisted_11 = {
  id: "listaDoCard",
  class: "d-flex flex-row justify-content-around align-items-center w-100"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "pontoLista" }, null, -1))
const _hoisted_13 = {
  class: "d-flex flex-row w-100",
  id: "listaVeiculosDoModal"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"card d-flex flex-row mt-4\" data-v-d0cefeac><img src=\"" + _imports_1 + "\" alt=\"\" style=\"padding-right:1.9rem;\" data-v-d0cefeac><div class=\"w-100 d-flex flex-column\" id=\"ulPaiListaCard\" data-v-d0cefeac><h6 class=\"titulosDoModal\" data-v-d0cefeac>Produto</h6><select class=\"mb-3\" id=\"selectModal\" data-v-d0cefeac><option value=\"\" data-v-d0cefeac>Oleo Lubrificante</option></select><select name=\"\" id=\"selectModal\" data-v-d0cefeac></select></div></div>", 1)
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn",
    "data-bs-dismiss": "modal"
  }, "Excluir")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("ul", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("li", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.targetClickCar.car.marca) + " - " + _toDisplayString(_ctx.targetClickCar.car.modelo), 1)
                ])
              ])
            ]),
            _hoisted_14
          ]),
          _hoisted_15
        ])
      ])
    ])
  ]))
}